import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/$')({
  beforeLoad: () => {
    redirect({ href: `${process.env.BASE_URL}`, throw: true });
  },
});
